import React from 'react';

export default function Spinning() {
  return <div>Loading ...</div>;
}
